export default __webpack_public_path__ + "static/media/NO_EMAIL_FOUND_ICON.685b317e.svg";